import React, { useState } from 'react';
import { Button, Steps, } from 'antd';
import { DataSource } from '../../../../repertoire/types/DataSource';
import { MessageBanner, MessageType } from "../../../../repertoire/components/messageBanner/MessageBanner";
import { ITabReduxItem } from '../../../../redux/types/ITabReduxItem';
import InvalidAdditionalNumbersAlert from '../../../../repertoire/works/components/workMaintenanceAccordion/InvaildAdditionalNumberAlert';
import { resetMessageBanner } from '../../../../redux/reducers/RepertoireReducer';
import ActionButton from '../../../../repertoire/components/actionButton/ActionButton';
import { MembersPortalService } from '../../../../redux/services/MembersPortalService';
import { MembersPortalRoles } from '../../../../redux/types/MembersPortalRoles';
import { ILookupDictionary } from '../../../../lookup/types/ILookupDictionary';
import { WORK_NUMBER_LOOKUP, INSTRUMENTATION_LOOKUP } from '../../../../lookup/Consts';
enum FormPages {
    PropertiesPage = 0,
    ContributorsPage = 1,
    AttachmentPage = 2,
    ArtistsPage = 3
}
export interface Step {
    title: string;
    content: any;
}
export interface IDraftWorksMaintenanceFormProps {
    steps: Step[];
    readonly: boolean;
    saveChanges: () => void;
    confirmAndSubmit: () => void;
    dataSource?: string;
    current?: number;
    setCurrent?: (current: number) => void;
    tabs?: ITabReduxItem
    activeTab?: number;
    resetMessageBanner: () => void;
    draftWorkMaintenanceGeneralDataViewData?: any;
    lookupValues?: ILookupDictionary;
}
const DraftWorksMaintenanceForm = (props) => {

    const [submit, setSubmit] = useState(false)
    const [errorMessages, setErrorMessages] = useState([]);
    const handleSubmit = async () => {
        setSubmit(await props.confirmAndSubmit());
    }
    const next = async () => {
        const { current, setCurrent, tabs, activeTab } = props;
        const next = current + 1;
        const state = tabs?.[activeTab]?.draftWorkMaintenanceState?.work;

        if (!state) {
            return;
        }
        try {
            switch (current) {
                case FormPages.PropertiesPage:
                    if (validatePropertiesPage(state)) {
                        setCurrent(next);
                    }
                    break;
                case FormPages.ContributorsPage: {
                    if (await props.saveChanges()) {
                        setCurrent(next);
                    }
                    break;
                }
                case FormPages.AttachmentPage:
                    setCurrent(next)
                    break;
                case FormPages.ArtistsPage:
                    if (validateArtistsPage(state)) {
                        setCurrent(next);
                    }
                    break;
            }
        } catch {
            return;
        }
    };
    const clearValidationState = () => {
        const { tabs, activeTab } = props;
        if (tabs?.[activeTab]) {
            tabs[activeTab].saveSuccessful = undefined;
        }
        setErrorMessages([]);
    };
    const prev = () => {
        const { current, setCurrent } = props;
        clearValidationState();
        setCurrent(current - 1);
    };
    const validatePropertiesPage = (state) => {
        const { draftWorkMaintenanceGeneralDataViewData } = props;
        const messages = [];
        if (String(state.originalTitle ?? '').trim() === '') {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "saveValidationWorkTitleNotSet").data);
        }
        if (state.duration <= 0) {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "saveValidationWorkDurationNotSet").data);
        }
        if (state.titles?.some(t =>
            t?.type?.value !== "OT"
            && (t?.type?.value != null || t?.language?.value != null || t?.title?.value != null)
            && (t?.title?.value == null || String(t.title.value).trim() === '')
        )) {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workNameValueInvalidMessage").data);
        }
        if (String(state.originalTitle ?? '').trim() === '' && state.titles?.some(t => t?.type?.value === "OT")) {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workNameOriginalTitleInvalidMessage").data);
        }
        if (state.numbers?.some(n => (n?.workNumberID ?? 0) < 0 && (
            n?.type?.value == null
            || String(n.type.value).trim() === ''
            || !props.lookupValues?.[WORK_NUMBER_LOOKUP]?.lookups?.some(l => l.code === n.type.value)
            || n?.number?.value == null
            || String(n.number.value).trim() === ''
        ))) {
            if (state.numbers?.some(n => (n?.workNumberID ?? 0) < 0 && (n?.type?.value == null || String(n.type.value).trim() === ''
                || !props.lookupValues?.[WORK_NUMBER_LOOKUP]?.lookups?.some(l => l.code === n.type.value)
            ))) {
                messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workNumberTypeInvalidMessage").data);
            }
            if (state.numbers?.some(n => (n?.workNumberID ?? 0) < 0 && (n?.number?.value == null || String(n.number.value).trim() === ''))) {
                messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workNumberValueInvalidMessage").data);
            }
        }

        const invalidFormattedWorkNumber = state.numbers?.find(n => {
            if ((n?.workNumberID ?? 0) < 0) {
                if (n?.type?.value == null || String(n.type.value).trim() === '') {
                    return false;
                }

                if (n?.number?.value == null || String(n.number.value).trim() === '') {
                    return false;
                }

                const workNumberLookup = props.lookupValues?.[WORK_NUMBER_LOOKUP]?.lookups?.find(l => l.code === n.type.value);
                if (workNumberLookup?.extraFields?.["FormatRegex"] != null) {
                    const regexString = workNumberLookup.extraFields["FormatRegex"].toString();
                    const pattern = new RegExp(regexString);
                    if (!pattern.test(String(n.number.value))) {
                        return true;
                    }
                }
            }

            return false;
        });

        if (invalidFormattedWorkNumber) {
            const workNumberLookup = props.lookupValues?.[WORK_NUMBER_LOOKUP]?.lookups?.find(
                l => l.code === invalidFormattedWorkNumber?.type?.value
            );
            const regexString = workNumberLookup?.extraFields?.["FormatRegex"]?.toString();
            const sampleNumber = workNumberLookup?.extraFields?.["SampleNumber"];
            const messageTemplate = draftWorkMaintenanceGeneralDataViewData?.fields.find(
                v => v.name == "workNumberFormatInvalidMessage"
            )?.data;
            const additionalInfo = `${regexString}, E.g. ${sampleNumber}`;

            messages.push(`${messageTemplate} ${additionalInfo}`);
        }

        if (state.instrumentation?.some(i => (i?.instrumentationID ?? 0) < 0 && (
            i?.type?.value == null
            || String(i.type.value).trim() === ''
            || !props.lookupValues?.[INSTRUMENTATION_LOOKUP]?.lookups?.some(l => l.code === i.type.value)
        ))) {
            messages.push(
                draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workInstrumentationCodeInvalidMessage")?.data
            );
        }
        if (messages.length > 0) {
            setErrorMessages(messages);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            return false;
        }
        setErrorMessages([]);
        return true;
    };
    const validateArtistsPage = (state) => {
        const { draftWorkMaintenanceGeneralDataViewData, lookupValues } = props;
        const messages = [];
        clearValidationState();

        if (state.artists?.some(a =>
            a?.type?.value == null
            || String(a.type.value).trim() === ''
            || !lookupValues?.["WorkPerformer"]?.lookups?.some(l => l.code === a.type.value)
        )) {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workPerformerTypeInvalidMessage")?.data);
        }

        if (state.artists?.some(a =>
            String(a?.fullName?.value ?? '').trim() === '' &&
            String(a?.firstName?.value ?? '').trim() === '' &&
            String(a?.lastName?.value ?? '').trim() === ''
        )) {
            messages.push(draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "workPerformerNameInvalidMessage")?.data);
        }

        if (messages.length > 0) {
            setErrorMessages(messages);
            return false;
        }

        return true;
    };
    const renderErrorMessages = (messages) => {
        const { resetMessageBanner } = props;
        return (
            <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={messages} />
        );
    };
    const items = props.steps.map((item) => ({ key: item.title, title: item.title }));
    const { current, dataSource, draftWorkMaintenanceGeneralDataViewData, tabs, activeTab } = props;
    const validationErrors = !!(errorMessages.length > 0);
    const menuName = tabs?.[activeTab]?.name;
    const hasPermission = MembersPortalService.hasPermissionForMenu(menuName, MembersPortalRoles.FullAccess);
    return (
        <>
            {validationErrors && renderErrorMessages(errorMessages)}
            {dataSource === DataSource.Intray ? <Steps current={current} items={items} /> : <></>}
            <div style={{ padding: '20px' }}>{props.steps?.[current]?.content}</div>
            {!(validationErrors && renderErrorMessages(errorMessages)) && document.querySelector('.loaderWrapper') == null && submit && <div
            >
                <MessageBanner messageType={MessageType.Success}
                    messages={[draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "draftSubmitted")?.data]}
                    resetMessageBanner={resetMessageBanner}
                />
            </div>
            }
            <div className="row">
                <div
                    className="btn-group form-group col-lg-2 col-lg-push-5 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                    style={{ marginTop: 24 }}
                >
                    {current > 0 && (
                        <Button data-testid={'prev'} className="button btn-defaultSecondary" onClick={() => prev()}>
                            {draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "previous").data}
                        </Button>
                    )}
                </div>
                <div
                    className="btn-group form-group col-lg-2 col-lg-push-5 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                    style={{ marginTop: 24 }}
                >
                    {current < props.steps.length - 1 && (
                        <Button data-testid={'next'} className="button btn-defaultSecondary" onClick={() => next()}>
                            {draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "next").data}
                        </Button>
                    )}
                </div>
                {current === props.steps.length - 1 && props.dataSource === DataSource.Intray && (
                    <>
                        <div
                            className="btn-group form-group col-lg-2 col-lg-push-3 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                            style={{ marginTop: 24 }}
                        >
                            <ActionButton buttonText={draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "saveRegistration").data}
                                buttonAction={() => props.saveChanges()}
                                className="button btn-defaultSecondary"
                                data-testid={'save-registration'}
                                showTooltip={!hasPermission} />
                        </div>
                        <div
                            className="btn-group form-group col-lg-2 col-lg-push-3 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                            style={{ marginTop: 24 }}
                        >
                            <ActionButton buttonText={draftWorkMaintenanceGeneralDataViewData?.fields.find(v => v.name == "confirmAndSubmitRegistration").data}
                                buttonAction={() => handleSubmit()}
                                className="button btn-defaultPrimary btn-confirm"
                                data-testid={'confirm-submit-registration'}
                                showTooltip={!hasPermission} />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
export default DraftWorksMaintenanceForm;